const EVENT_NAME = 'header_events'

const HEADER_PAGE_TYPES = {
  INDEX: 'index',
  CLP: 'clp',
  BT_PAGES: 'bt_pages'
} as const

const HEADER_TAB_EVENT_CATEGORIES: Record<string, string> = {
  FLT: 'book',
  MMB: 'manage',
  CKI: 'check_in',
  plan: 'plan',
  prepare: 'prepare',
  'airbaltic-club': 'airbaltic_club',
  'need-help-navigation': 'need_help'
}

export default function () {
  const route = useRoute()
  const { locale } = useI18n()
  const siteLanguage = locale
  const routePageType = computed(() => (typeof route.meta.pageType === 'string' ? route.meta.pageType : ''))

  const pageType = computed(() => {
    if (routePageType.value === HEADER_PAGE_TYPES.INDEX) {
      return HEADER_PAGE_TYPES.INDEX
    }

    if (route.path.includes('/campaign/')) {
      return HEADER_PAGE_TYPES.CLP
    }

    return HEADER_PAGE_TYPES.BT_PAGES
  })

  const base = computed(() => ({
    event: EVENT_NAME,
    site_language: siteLanguage.value,
    page_type: pageType.value
  }))

  function pushHeaderDataLayer(data: object) {
    if (!isDataValid(data)) {
      return
    }

    pushToDataLayer({
      ...base.value,
      ...data
    })
  }

  function pushHeaderTabClickDataLayer(eventCategory: string) {
    if (!eventCategory) {
      return
    }

    pushHeaderDataLayer({
      generic_event_name: 'header_tabs_clicks',
      event_category: eventCategory
    })
  }

  function getHeaderTabEventCategory(value: string) {
    return HEADER_TAB_EVENT_CATEGORIES[value] ?? HEADER_TAB_EVENT_CATEGORIES[value.trim().toLowerCase()] ?? ''
  }

  function pushHeaderSubcategoryCardClickDataLayer(eventCategory: string, eventLabel: string) {
    if (!eventCategory || !eventLabel) {
      return
    }

    pushHeaderDataLayer({
      generic_event_name: 'header_subcategory_blog_cards',
      event_category: eventCategory,
      event_label: eventLabel
    })
  }

  function pushHeaderBurgerMenuClickDataLayer() {
    pushHeaderDataLayer({
      generic_event_name: 'header_burger_menu_clicks'
    })
  }

  function pushHeaderLoginClickDataLayer() {
    pushHeaderDataLayer({
      generic_event_name: 'header_login_clicks'
    })
  }

  function pushHeaderLanguageChangeDataLayer(eventCategory: string) {
    if (!eventCategory) {
      return
    }

    pushHeaderDataLayer({
      generic_event_name: 'language_change',
      event_category: eventCategory
    })
  }

  function pushHeaderSpecialAssistanceClickDataLayer() {
    pushHeaderDataLayer({
      generic_event_name: 'header_special_assistance_clicks'
    })
  }

  function pushHeaderLogoClickDataLayer() {
    pushHeaderDataLayer({
      generic_event_name: 'header_logo_clicks'
    })
  }

  function isDataValid(data: object) {
    if (data === null || typeof data !== 'object' || !Object.values(data).length) {
      if (isDev()) {
        console.error('Pass valid data object to Header data layer')
      }

      return false
    }

    return true
  }

  return {
    pageType,
    pushHeaderDataLayer,
    pushHeaderTabClickDataLayer,
    getHeaderTabEventCategory,
    pushHeaderSubcategoryCardClickDataLayer,
    pushHeaderBurgerMenuClickDataLayer,
    pushHeaderLoginClickDataLayer,
    pushHeaderLanguageChangeDataLayer,
    pushHeaderSpecialAssistanceClickDataLayer,
    pushHeaderLogoClickDataLayer
  }
}
